'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TiktokIcon = exports.InstagramCarouselIcon = exports.InstagramStoryIcon = exports.BlogIcon = exports.TelegramIcon = exports.TwitchIcon = exports.PinterestIcon = exports.TwitterIcon = exports.InstagramIcon = exports.FacebookIcon = exports.YoutubeIcon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tiktok = 'https://app.dyzio.co/logos/tiktok-logo.svg';

var twitterLogoStyle = {
  color: '#1dcaff'
};

var facebookLogoStyle = {
  color: '#3B5998'
};

var telegramLogoStyle = {
  color: '#24a4e3'
};

var YoutubeIcon = exports.YoutubeIcon = function YoutubeIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube', size: size, color: 'red' });
};

var FacebookIcon = exports.FacebookIcon = function FacebookIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', size: size, style: facebookLogoStyle });
};

var InstagramIcon = exports.InstagramIcon = function InstagramIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', size: size, color: 'pink' });
};

var TwitterIcon = exports.TwitterIcon = function TwitterIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter', size: size, style: twitterLogoStyle });
};

var PinterestIcon = exports.PinterestIcon = function PinterestIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'pinterest', size: size, color: 'red' });
};

var TwitchIcon = exports.TwitchIcon = function TwitchIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitch', size: size, color: 'purple' });
};

var TelegramIcon = exports.TelegramIcon = function TelegramIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'telegram', size: size, style: telegramLogoStyle });
};

var BlogIcon = exports.BlogIcon = function BlogIcon(props) {
  var size = props.size;

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe', size: size, color: 'blue' });
};

var InstagramStoryIcon = exports.InstagramStoryIcon = function InstagramStoryIcon(props) {
  var size = props.size;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(InstagramIcon, { size: size }),
    _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', size: size, color: 'pink' })
  );
};

var InstagramCarouselIcon = exports.InstagramCarouselIcon = function InstagramCarouselIcon(props) {
  var size = props.size;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(InstagramIcon, { size: size }),
    _react2.default.createElement(_semanticUiReact.Icon, { name: 'clone outline', size: size, color: 'pink' })
  );
};

var TiktokIcon = exports.TiktokIcon = function TiktokIcon(_ref) {
  var additionalStyles = _ref.additionalStyles;

  var style = (0, _extends3.default)({
    width: 15,
    height: 15,
    display: 'inline-block',
    margin: 5
  }, additionalStyles);
  return _react2.default.createElement(_semanticUiReact.Image, { src: Tiktok, style: style });
};

TiktokIcon.propTypes = {
  additionalStyles: _propTypes2.default.bool
};

TiktokIcon.defaultProps = {
  additionalStyles: {}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/dyzio-icons/index.js
 ** module id = 600
 ** module chunks = 0
 **/